import {BreakpointObserver} from "../../../services/breakpoints/BreakpointObserver";
import {Observable} from "rxjs";
import {ViewType} from "../types/ViewType";
import {Breakpoint} from "../../../services/breakpoints/Breakpoint";

export class ClientDashboardViewStore {

    public static id = "clientDashboardViewStore";

    private readonly viewType$: Observable<ViewType>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.viewType$ = this.buildViewSize();
    }

    private buildViewSize() {
        return this.breakpointObserver
                   .map(change => change.current)
                   .map((current) => this.breakpointToType(current))
                   .publishReplay(1)
                   .refCount();
    }

    private breakpointToType(breakpoint: Breakpoint) {
        switch (breakpoint) {
            case Breakpoint.XL:
            case Breakpoint.LG:
                return  "desktop";
            case Breakpoint.MD:
                return  "tablet";
            case Breakpoint.SM:
            case Breakpoint.XS:
                return  "mobile";
            default:
                return "desktop";
        }
    }

    public get viewType(): Observable<ViewType> {
        return this.viewType$;
    }
}
